import { EstacionPopup } from './estacion-popup';
import { PopupInfoItem } from './entity-popup.interface';

/**
 * Popup para estaciones de humedad del suelo.
 * Muestra hasta 4 niveles de humedad del suelo.
 */
export class HumedadPopup extends EstacionPopup {
  getBadgeText(): string {
    return `Estación Humedad de ${this.entity.provider} (Id ${this.entity.provider_id})`;
  }

  getInfoItems(): PopupInfoItem[] {
    const icon = 'humidity_low';
    const unit = '%';

    return [
      this.createSensorItem(
        this.entity.soil_moisture1_last,
        'Humedad del suelo 1',
        icon,
        unit
      ),
      this.createSensorItem(
        this.entity.soil_moisture2_last,
        'Humedad del suelo 2',
        icon,
        unit
      ),
      this.createSensorItem(
        this.entity.soil_moisture3_last,
        'Humedad del suelo 3',
        icon,
        unit
      ),
      this.createSensorItem(
        this.entity.soil_moisture4_last,
        'Humedad del suelo 4',
        icon,
        unit
      ),
    ];
  }
}
